import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import CustomInput from '../../../CustomComponents/FormInputs'
import { useLocation, useNavigate, Link } from 'react-router-dom'
import { withOidcSecure } from '@axa-fr/react-oidc';
import Modal from "../../../CustomComponents/Modal";
import ClimbIcon from '../../../../assets/images/illo-climb.png';
import { useDispatch, useSelector, connect } from 'react-redux';
import { SAVING, appTheme, retrieveData } from '../../../../helpers/utils/Utils';
import { STATUS_SUCCESS_CODE, GET_CLIMB_FEATURES, CLIMB_OPT_IN_OUT, AGREEMENTS, SAVING_CARD_CODE } from '../../../../network/URLConstants';
import { GetApiHeadersWithBearer, GetRequest, PostRequest } from '../../../../network/NetworkUtils';
import Loader from '../../../CustomComponents/Loader';
import Tickicon from '../../../../assets/images/Check_white.png';
import SpendIcon1 from '../../../../assets/images/illo-spendsense.png';
import SpendIcon2 from '../../../../assets/images/spend_alert_2.png';
import SavingHabitIcon1 from '../../../../assets/images/savings-habits-1.png';
import RadialFill from '../../../../assets/images/Checkbox-blue.png'
import RadialNull from '../../../../assets/images/Checkbox-light.png'
import { CHECKING_CARD_CODE } from "../../../../helpers/utils/Utils";
import CoveredByKudzuIcon1 from '../../../../assets/images/savings-habits.png';
import LineBreaks, { addLineBreaks, displayErrorMessage } from "../../../../utils";
import CustomAlertModel from "../../../CustomComponents/CustomAlertModel";
import { useKeyDown } from "../../../../hooks/useKeyDown";
import debounce from 'lodash.debounce';
import logFirebaseEvents from "../../../LogFirebaseEvents";
import CustomModalPlus from "../../../../kudzu_plus/helpers/customModalPlus";
import ArrowWhite from '../../../../assets/kudzu-plus-images/arrow-image.png';
import { getUserMembership } from "../../../../helpers/utils/Utils";
import { useDocumentTitle } from '../../../../hooks/useDocumentTitle';





const CoveredByKudzu = () => {

    const navigate = useNavigate();
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue); 
    const appThemeData = appTheme(kudzuPlusTrue);
    const { t } = useTranslation();
    useDocumentTitle(t('page_title_covered_by_kudzu'));

    const [infoMessage, setinfoMessage] = useState('');
    const dispatch = useDispatch();
    
    const [isLoading, setIsLoading] = useState(false);
    const [isClimbModalOpen, setIsClimbModalOpen] = useState(true);
    const cards = useSelector(state => JSON.parse(state.userCards));
    const accessToken = useSelector(state => state.accessToken);
    const [isClimbings, setisClimbings] = useState([]);
    const [disclosureAgrmt, setDisclosureAgrmt] = useState(false);
    const [showPolicys, setShowPolicys] = useState('terms');
    const [renderModel, setRenderModel] = useState('');
    const [policyURL, setPolicyURL] = useState('');
    const [showAgreementsModel, setShowAgreementsModel] = useState(false);

    //Covered By Kudzu
    const [IsCoveredByKudzuModalOpen1, setIsCoveredByKudzuModalOpen1] = useState(false);
    const [isCoveredByKudzuModalOpen2, setIsCoveredByKudzuModalOpen2] = useState(false);
    const [isCoveredByKudzuModalOpen3, setIsCoveredByKudzuModalOpen3] = useState(false);
    const [isCoveredByKudzuDiscloserOpen, setIsCoveredByKudzuDiscloserOpen] = useState(false);
    const [isCoveredByKudzuOptInSuccess, setIsCoveredByKudzuOptInSuccess] = useState(false);
    const [isCoveredByKudzuIneligible, setIsCoveredByKudzuIneligible] = useState(false);
    const [isCoveredByKudzuIneligibleSetupSavings, setIsCoveredByKudzuIneligibleSetupSavings] = useState(false);
    const [isCoveredByKudzuIneligibleSetupSavingsPostPopup, setIsCoveredByKudzuIneligibleSetupSavingsPostPopup] = useState(false);
    const [showModel, setShowModel] = useState(false);
    const HighlightMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal  text-[var(--modal-text-highlight)] cursor-pointer pointer-events-none";
    const HeaderMsgStyles = "font-serif-pro modal-title text-[var(--modal-text-heading-clr)] lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal cursor-pointer pointer-events-none";
    const SubHeaderMsgStyles = "font-hanken-grotesk text-[var(--modal-text-heading-clr)] modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer pointer-events-none";
    const summaryParagraphStyles = "font-hanken-grotesk modal-title text-white lg:text-[13px] md:text-[13px] sm:text-[6px] text-[8px] font-[400] cursor-pointer pointer-events-none";
    const SubHeaderMsgStylesPlus = "font-hanken-grotesk modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer pointer-events-none text-[var(--modal-text-heading-clr)]";
    const HeaderMsgStylesForPlus = "font-serif-pro text-white modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal cursor-pointer pointer-events-none";
    
    const [modelImage, setModelImage] = useState('')
    const [highlightMsg, setHighlightMsg] = useState('')
    const [headerMsg, setheaderMsg] = useState('')
    const [subHeaderMsg, setSubHeaderMsg] = useState('')
    const [btn1Exists, setBtn1Exists] = useState(false)
    const [btn2Exists, setBtn2Exists] = useState(false)
    const [btn1Text, setBtn1Text] = useState(false)
    const [btn2Text, setBtn2Text] = useState('')
    const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
    const [type, setType] = useState('')
    const [footerMsg, setFooterMsg] = useState('');
    const [carousel, setCarousel] = useState('');
    const [summaryParagraph, setSummaryParagraph] = useState('');
    const [opacityValueLow, setOpacityValueLow] = useState(false);
    const [showPlusModal, setShowPlusModal] = useState(false);
    const [comparisonScreen, setComparisonScreen] = useState('');
    const [fullWidth, setFullWidth] = useState(false);
    const [footerButtonEnable, setFooterButtonEnable] = useState(false);
    const [gradientButton, setGradientButton] = useState(false);
    const [largeImage, setLargeImage] = useState(false);
    const [btn1BgColor, setBtn1BgColor] = useState("");
    const [subFooter, setSubFooter] = useState('');
    const [skipAndNextButtonsEnable, setSkipAndNextButtonsEnable] = useState(false);
    const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));
    const userMembershipData = getUserMembership(loggedResponse)



    const isPrimrayKey = cards !== null ? cards[0].CardKey : 0;
    const hasSavingsAccount = cards?.some(item => item.AccountTypeName === "Savings");
    const SavingsAccount = cards?.find(({AccountTypeBit63}) => AccountTypeBit63 === SAVING_CARD_CODE);

    const isMobile = /Mobi|Android/i.test(navigator.userAgent);
    const savingsWithBalanceOver50 = cards.find(
        obj => obj.AccountTypeBit63 == 32 && obj.Balance >= 50
      );
    // const isMobile = false
    const location = useLocation();
    const stateFrom = location.state;





    const SubHeadingStyles = "font-serif-pro modal-title sm:text-[18px] lg:text-[32px] md:text-[28px] text-[25px] sm:leading-[24px] lg:leading-[38px] md:leading-[33px] leading-[31px] font-normal text-[var(--modal-text-heading-clr)]";
    const SubHeadingStyles2 = "font-serif-pro modal-title sm:text-[18px] lg:text-[32px] md:text-[28px] text-[25px] sm:leading-[24px] lg:leading-[38px] md:leading-[33px] leading-[31px] font-normal text-[var(--modal-text-highlight)] pl-1 pr-1 mb-4";
    const SubHeadingStyles4 = "font-serif-pro modal-title sm:text-[18px] lg:text-[32px] md:text-[28px] text-[25px] sm:leading-[24px] lg:leading-[38px] md:leading-[33px] leading-[31px] font-normal text-[var(--modal-text-highlight)] mb-4";
    const SubHeadingStyles3 = "font-hanken-grotesk modal-title sm:text-[18px] lg:text-[20px] md:text-[20px] text-[20px] sm:leading-[30px] lg:leading-[38px] md:leading-[30px] leading-[30px] font-normal text-[var(--modal-text-heading-clr)]";
    const [isBorderNone, setisBorderNone] = useState(true);
    const [showErrorImg, setshowErrorImg] = useState(false);
    //close modal redirection to manage cards
     const accessTokenToApi = useSelector((state) => state.accessToken);

    const handleClick = (type) => {  
        logFirebaseEvents("Covered_By_Kudzu", "Terms_Condition_Covered_By_Kudzu_Clicked", "Terms_Condition_Covered_By_Kudzu_Clicked","", "");
        setShowPolicys((prevState) => {
            if (type === 'userAgreement') {
                LinkClick("user agreement");
            }
        });

    };

    const LinkClick = (href) => {
        // e.preventDefault();
        // e.stopPropagation();

        switch (href) {
            case "user agreement":
                getAgreementsBasedOnType("CoveredByKudzuTerms")
                // setShowAgreementsModel(true);
                break;

            default:
                break;
        }
    };

    const getAgreementsBasedOnType = async (url) => {
        if (isPrimrayKey == undefined || isPrimrayKey == null) {
            return
        }
        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
        setIsLoading(true)

        // let finalUrl = (PROGRAM_CONTENT + "?accountType=64&language=en&contentType=" + url + "&programKey=200")
        let finalUrl = AGREEMENTS.replace('{contentType}', url).replace('{cardKey}', isPrimrayKey)
        var response = await GetRequest(finalUrl, headers)
        var responseObj = JSON.parse(response)
        setIsLoading(false)
        if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
            setRenderModel(responseObj.Response.RenderModel);
            setPolicyURL(responseObj.Response.Content);
            setShowAgreementsModel(true);
        } else {
            setTimeout(() => {
                var arrMessages = responseObj.Messages;
                var message = arrMessages[0];
                var displayText = message.DisplayText;
                // setError(displayText)
            }, 500);
        }
    }




    const closeSkipModal = () => {
        logFirebaseEvents("Covered_By_Kudzu", "Skip_Covered_By_Kudzu_Clicked", "Skip_Covered_By_Kudzu_Clicked","", "");

        if (!hasSavingsAccount) {
            {
                setIsCoveredByKudzuModalOpen1(false);
                setIsCoveredByKudzuModalOpen2(false);
                setIsCoveredByKudzuModalOpen3(false);
                setIsCoveredByKudzuIneligible(false)
                setIsCoveredByKudzuDiscloserOpen(false)
                setIsCoveredByKudzuIneligibleSetupSavings(true)
                setIsCoveredByKudzuIneligibleSetupSavingsPostPopup(false)
            }
        }else if (hasSavingsAccount && savingsWithBalanceOver50 == undefined) {
            {
                setIsCoveredByKudzuModalOpen1(false);
                setIsCoveredByKudzuModalOpen2(false);
                setIsCoveredByKudzuModalOpen3(false);
                setIsCoveredByKudzuDiscloserOpen(false)
                setIsCoveredByKudzuIneligibleSetupSavings(false)
                setIsCoveredByKudzuIneligibleSetupSavingsPostPopup(false)
                setIsCoveredByKudzuIneligible(true)
            }
        }
        else {
            if (SavingsAccount.OTB >= 50) {
                setIsCoveredByKudzuModalOpen1(false);
                setIsCoveredByKudzuModalOpen2(false);
                setIsCoveredByKudzuModalOpen3(false);
                setIsCoveredByKudzuIneligibleSetupSavings(false)
                setIsCoveredByKudzuIneligibleSetupSavingsPostPopup(false)
                setIsCoveredByKudzuIneligible(false)
                setIsCoveredByKudzuDiscloserOpen(true)
            } else {

                setIsCoveredByKudzuModalOpen1(false);
                setIsCoveredByKudzuModalOpen2(false);
                setIsCoveredByKudzuModalOpen3(false);
                setIsCoveredByKudzuDiscloserOpen(false)
                setIsCoveredByKudzuIneligibleSetupSavings(false)
                setIsCoveredByKudzuIneligibleSetupSavingsPostPopup(false)
                setIsCoveredByKudzuIneligible(true)
            }
        }
    };



    const coveredByKudzuOptIn = async (item) => {
        if (cards == null || cards == undefined) {
            return
        }

        setIsCoveredByKudzuModalOpen1(false);
        setIsCoveredByKudzuModalOpen2(false);
        setIsCoveredByKudzuModalOpen3(false);
        setIsCoveredByKudzuDiscloserOpen(false);

        setIsLoading(true);
        const url = CLIMB_OPT_IN_OUT.replace('{CARD_KEY}', cards.find((item) => (item.AccountTypeBit63 == CHECKING_CARD_CODE)).CardKey) + 'CoveredByKudzu' + '/opt-in'
        const deviceId = await retrieveData('updatedDeviceId')
        const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
        const response = await PostRequest(url, {}, headers)

        setTimeout(() => {
            setIsLoading(false)
        }, 500);

        const responseObj = JSON.parse(response);

        if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
            setIsCoveredByKudzuOptInSuccess(true);
        } else {
            setIsCoveredByKudzuDiscloserOpen(false);
            var arrMessages = responseObj.Messages;
            var message = arrMessages[0];
            var displayText = message.DisplayText;
            showAlertModal(true, t("covered_by_cudzu"), displayText, '', true, false, t("home"), '', true, require('../../../../assets/images/warning.png'), false, false)
        }

    }

    const MangageSpendAlerts = () => {
        // alert('HIASHS');
        navigate('/Toolkit/ToolkitMenu');
    }

    // Covered By Kudzu 
    const handleCoveredByKudzuIntro1=()=>{
        setIsCoveredByKudzuModalOpen1(true);
    }
    const handleCoveredByKudzuIntro2 = () => { 
        logFirebaseEvents("Covered_By_Kudzu", "Learn_More_Covered_By_Kudzu_Clicked", "Learn_More_Covered_By_Kudzu_Clicked","", "");
        setIsCoveredByKudzuModalOpen1(false);
        setIsCoveredByKudzuModalOpen2(true);
        setIsCoveredByKudzuModalOpen3(false);
        setIsCoveredByKudzuDiscloserOpen(false)
        setIsCoveredByKudzuIneligibleSetupSavings(false)
        setIsCoveredByKudzuIneligibleSetupSavingsPostPopup(false)
        setIsCoveredByKudzuIneligible(false)
    }

    const handleCoveredByKudzuIntro3 = () => {
        logFirebaseEvents("Covered_By_Kudzu", "Continue_Covered_By_Kudzu_Clicked", "Continue_Covered_By_Kudzu_Clicked","", "");
        setIsCoveredByKudzuModalOpen1(false);
        setIsCoveredByKudzuModalOpen2(false);
        setIsCoveredByKudzuModalOpen3(true);
        setIsCoveredByKudzuDiscloserOpen(false)
        setIsCoveredByKudzuIneligibleSetupSavings(false)
        setIsCoveredByKudzuIneligibleSetupSavingsPostPopup(false)
        setIsCoveredByKudzuIneligible(false)
    };
    const handleCoveredIntro3Skipped = () => {
        setIsCoveredByKudzuModalOpen1(false);
        setIsCoveredByKudzuModalOpen2(false);
        setIsCoveredByKudzuModalOpen3(false);
        setIsCoveredByKudzuDiscloserOpen(false)
        setIsCoveredByKudzuIneligibleSetupSavings(false)
        setIsCoveredByKudzuIneligibleSetupSavingsPostPopup(false)
        setIsCoveredByKudzuIneligible(false)
    };

    useEffect(() => {
        if (stateFrom == 'optinForCBK') {
            closeSkipModal()
        }
        else {
            setTimeout(() => {
                setIsCoveredByKudzuModalOpen1(true);
            }, 100)
        }
    }, [])



    const showAlertModal = (showModel, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, showErrorImg, isBorderNone) => {
        setshowErrorImg(showErrorImg)
        setisBorderNone(isBorderNone)
        setShowModel(showModel)
        setHighlightMsg(highlightMsg)
        setheaderMsg(headerMsg)
        setSubHeaderMsg(subHeaderMsg)
        setBtn1Exists(btn1Exists)
        setBtn2Exists(btn2Exists)
        setBtn1Text(btn1Text)
        setBtn2Text(btn2Text)
        setBtn1TypeAcpt(btn1TypeAcpt)
        setModelImage(modelImage)
    }
    const showAlertModalPlus = (showPlusModal, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, carousel, isBorderNone, btn1BgColor, summaryParagraph, opacityValue, comparisonScreen, fullWidth, footerButtonEnable, gradientButton, largeImage,subFooter) => {
        setShowPlusModal(showPlusModal)
        setHighlightMsg(highlightMsg)
        setheaderMsg(headerMsg)
        setSubHeaderMsg(subHeaderMsg)
        setBtn1Exists(btn1Exists)
        setBtn2Exists(btn2Exists)
        setBtn1Text(btn1Text)
        setBtn2Text(btn2Text)
        setBtn1TypeAcpt(btn1TypeAcpt)
        setModelImage(modelImage)
        setBtn1Exists(btn1Exists)
        setBtn1Text(btn1Text)
        setCarousel(carousel)
        setisBorderNone(isBorderNone)
        setBtn1BgColor(btn1BgColor)
        setSummaryParagraph(summaryParagraph)
        setOpacityValueLow(opacityValue)
        setComparisonScreen(comparisonScreen)
        setFullWidth(fullWidth)
        setFooterButtonEnable(footerButtonEnable)
        setGradientButton(gradientButton)
        setLargeImage(largeImage)
        setSubFooter(subFooter)
      }
    
    const closeCustomAlertModal = () => {

        setIsCoveredByKudzuDiscloserOpen(false);
        setShowModel(false);
        // if (highlightMsg == t('covered_by_cudzu')) { 
        navigate('/Toolkit/ToolkitMenu');
        //  }
    }
    const onAcptBtnClick = async () => {
        navigate('/home')

    }
    const onCancelBtnClick = () => {

    }

    useKeyDown(() => {
        if (isCoveredByKudzuIneligibleSetupSavings) {
            setIsCoveredByKudzuIneligibleSetupSavings(false);
            setIsCoveredByKudzuIneligibleSetupSavingsPostPopup(true);
        } else if (isCoveredByKudzuIneligibleSetupSavingsPostPopup) {
            navigate('/SetupSavingsAccount');
            dispatch({ type: 'SSN_SCREEN_THROUGH', payload: { ssnScreenThrough: t('climb_savings_enrollment') } });
        }
    }, ["Enter"]);


    const closeModelPlus = () => {
        setShowPlusModal(false)
        navigate('/Toolkit/ToolkitMenu');
    }
    const onAcptBtnClickPlusModal = () => {
        
    }

    const onCancelBtnClickPlusModal = () => {

    }

    const handleTermsClick = () =>{
        if (accessTokenToApi == undefined || accessTokenToApi == null) {
          return;
      }
      else {
          navigate('/Documents/Policies/Covered%20by%20Kudzu%20Terms%20and%20Conditions', { state: { name: 'Covered by Kudzu Terms and Conditions', 
            url:
            userMembershipData?.membershipType === "Plus" ||
            userMembershipData?.membershipType === "Trial"
            ? "CoveredByKudzuPlusTerms"
            : "CoveredByKudzuTerms",
            accType: 64, CardKey: cards?.[0]?.CardKey } });
      
      }
      }



    return (
        <>

            <>
                {/* //Covered By Kudzu intro 1 */}

                {IsCoveredByKudzuModalOpen1 &&<Modal
                    isOpen={IsCoveredByKudzuModalOpen1}
                    onClose={closeCustomAlertModal}
                    // onClose={debounce(closeCustomAlertModal, 100)}
                    isClimbg={true}
                    subtitle={<>
                        <span className={SubHeadingStyles}>{t("opt_in_to")}</span>
                        <span className={SubHeadingStyles2}>{t("kudzu_star")}</span>
                        <span className={SubHeadingStyles}>{t("to_make_sure_your_covered_with_money")}</span>
                    </>
                    }
                    content={<div className="pt-10 pb-10">
                        <img src={appThemeData.climbCoveredByKudzu} className="block sm:m-auto mx-auto lg:w-[220px] lg:h-[220px] 
          md:w-[170px] md:h-[170px] w-[129px] h-[129px] my-16" alt="" />
                        <p className="font-hanken-grotesk font-[400]
                                   text-[12px] leading-[18px]
                                 text-[var(--cover-by-kudzu)] mb-16">{t("cbk_intro2_subtext")}<span className="underline cursor-pointer" onClick={handleTermsClick}>{t("cbk_link")}</span></p>
                        {/* <div className="sm:absolute md:right-[-50px] sm:right-[0px] bottom-[0.5rem] w-full"> */}
                            <div className="flex sm:justify-end justify-between md:gap-14 sm:gap-8">

                                <button
                                    type="button"
                                    className="font-hanken-grotesk sm:font-bold font-[600]
                                  lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
                                 text-[var(--climbSkipTextColor)] flex items-center disabled"
                                    onClick={debounce(closeSkipModal, 100)}
                                >
                                    {t('skip')}
                                </button>
                                <button
                                    type="button"
                                    autoFocus
                                    className="focus:outline-none font-hanken-grotesk sm:font-bold font-[600]
                                lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-[var(--notificationResetclr)]
                                 cursor-pointer flex items-center"
                                    onClick={debounce(handleCoveredByKudzuIntro2, 100)}
                                >
                                    {t('learn_more')}<img
                                        src={appThemeData.arrowWhiteTwofac}
                                        className="md:w-[14px] sm:w-[11px] md:h-[14px] sm:h-[11px] w-[14px]
                     h-[14px] ml-1"
                                        alt="" />
                                </button>
                            </div>
                        {/* </div> */}
                    </div>}
                />}


                {/* //Covered By Kudzu intro 2 */}
                {isCoveredByKudzuModalOpen2 &&<Modal
                    isOpen={isCoveredByKudzuModalOpen2}
                    onClose={debounce(closeCustomAlertModal, 100)}
                    isClimbg={true}
                    subtitle={kudzuPlusTrue ? <><p className={SubHeadingStyles}><span className={SubHeadingStyles2}>{t('A_minimum_of_$50')}</span> {addLineBreaks(t('in_your_savings_balance_is_required'))}</p></> :
                    <> 
                        <p className={`${SubHeadingStyles} block`}>{t("covered_by_kudzu2_heading1")}
                            <span className={SubHeadingStyles2}>{t("covered_by_kudzu2_heading2")}</span></p>

                    </>
                    }
                    content={<div className=" m-auto md:pt-16 pt-8 pb-5 h-auto w-full flex flex-col">
                        <img src={appThemeData.climbOverageMonth}
                            className="block sm:m-auto mx-auto lg:w-[300px] lg:h-[280px] 
                            md:w-[320px] md:h-[313px] sm:[240px] sm:h-[220px] w-[250px] h-[230px]" alt="" />
                        <div className="w-full flex flex-row justify-between lg:mt-32 md:mt-20 mt-20">
                            <div>
                                <button
                                    type="button"
                                    className="sm:block hidden font-hanken-grotesk sm:font-bold font-[600]
                                 lg:text-[18px] md:text-[17px] sm:text-[13px] text-[16px] text-[var(--modal-text-heading-clr)]"
                                >
                                    {t('questions_see_our')} <Link to="/Help/FAQ" onClick={() => { logFirebaseEvents("Covered_By_Kudzu", "Faq_Covered_By_Kudzu_Clicked", "Faq_Covered_By_Kudzu_Clicked","", ""); }}
                                            className="text-[#99AED7]">{t('faq')}</Link>
                                </button>

                                <button
                                    type="button"
                                    className="sm:hidden block font-hanken-grotesk sm:font-bold font-[600]
                                 lg:text-[18px] md:text-[17px] sm:text-[13px] text-[16px] text-[#000000]"
                                >  <Link to="/Help/FAQ"
                                    className="text-[#99AED7]">{t('faq')}</Link>
                                </button>
                            </div>

                            <div className="">
                                <div className="sm:absolute md:right-[-6rem] sm:right-[-4rem] flex sm:justify-end justify-end md:gap-14 sm:gap-8">
                                    <button type="button" className="sm:flex hidden font-hanken-grotesk sm:font-bold font-[600]
 lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
 text-[#99AED7]  items-center disabled"  onClick={debounce(closeSkipModal, 100)}> {t('skip')}</button>

                                    <button type="button" className="font-hanken-grotesk sm:font-bold font-[600]
 lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-[var(--transactions-filter-blue-text)]
 cursor-pointer flex items-center focus:outline-none  " onClick={debounce(handleCoveredByKudzuIntro3, 100)} autoFocus> {t('continue')}<img src={appThemeData.arrowWhiteTwofac} className="md:w-[14px] sm:w-[11px]
  md:h-[14px] sm:h-[11px] w-[14px] h-[14px] ml-1" alt="" /> </button></div></div>

                        </div>
                    </div>}
                />}

                {/* //Covered By Kudzu intro 3 */}

                {isCoveredByKudzuModalOpen3 && <Modal
                    isOpen={isCoveredByKudzuModalOpen3}
                    onClose={debounce(closeCustomAlertModal, 100)}
                    isClimbg={true}
                    subtitle={ kudzuPlusTrue ? <><p className={SubHeadingStyles2}>{<span className={SubHeadingStyles}>{t('Covered_by_Kudzu_protection_may_be_engaged')}</span>} {t('up_to_10_times_per_month')}</p></> : 
                    <>
                        <span className={SubHeadingStyles} style={{ width: '453px' }}>{(t('to_opt_in_you_just_need'))} </span>
                        <span className={SubHeadingStyles2}>{t('a_minimum_of_$50_available')}</span>
                        <span className={SubHeadingStyles}>{t("in_your_savings_account")}</span>
                    </>
                    }
                    content={
                        <div className="m-auto pt-5 pb-5 h-auto w-full flex flex-col">
                            <img src={appThemeData.kudzu_$50_kudzuplusIcon}
                                alt=""
                                className="block sm:m-auto mx-auto
                                 w-[129px] h-[129px] my-16" />
                            <div className="w-full flex flex-row justify-between mt-40">
                                <button
                                    type="button"
                                    className="sm:block hidden font-hanken-grotesk sm:font-bold font-[600]
                                     lg:text-[18px] md:text-[17px] sm:text-[13px] text-[16px]  text-[var(--modal-text-heading-clr)]">
                                    {t('questions_see_our')} <Link to="/Help/FAQ"
                                        className="text-[#99AED7]">{t('faq')}</Link>
                                </button>
                                <button
                                    type="button"
                                    className="sm:hidden block font-hanken-grotesk sm:font-bold font-[600] 
                                    lg:text-[18px] md:text-[17px] sm:text-[13px] text-[16px]  text-[var(--modal-text-heading-clr)]" >
                                    <Link 
                                        to="/Help/FAQ"
                                        onClick={() => { logFirebaseEvents("Covered_By_Kudzu", "Faq_Covered_By_Kudzu_Clicked", "Faq_Covered_By_Kudzu_Clicked","", "");  }}
                                        className="text-[#99AED7] bg-transparent border-0 p-0 underline cursor-pointer font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[13px] text-[16px]">
                                        {t('faq')}
                                    </Link>
                                </button>
                                <button
                                    type="button"
                                    autoFocus
                                    className="focus:outline-none   font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px]
                                     md:text-[17px] sm:text-[13px] text-[16px] text-[var(--transactions-filter-blue-text)] cursor-pointer flex items-center"
                                    onClick={
                                        debounce(() => {

                                            if (!hasSavingsAccount) {
                                                {
                                                    setIsCoveredByKudzuModalOpen1(false);
                                                    setIsCoveredByKudzuModalOpen2(false);
                                                    setIsCoveredByKudzuModalOpen3(false);
                                                    setIsCoveredByKudzuIneligibleSetupSavings(true)
                                                }
                                            }
                                            else {

                                                if (SavingsAccount.Balance >= 50) {
                                                    setIsCoveredByKudzuModalOpen1(false);
                                                    setIsCoveredByKudzuModalOpen2(false);
                                                    setIsCoveredByKudzuModalOpen3(false);
                                                    setIsCoveredByKudzuDiscloserOpen(true)
                                                } else {
                                                    setIsCoveredByKudzuModalOpen1(false);
                                                    setIsCoveredByKudzuModalOpen2(false);
                                                    setIsCoveredByKudzuModalOpen3(false);
                                                    setIsCoveredByKudzuIneligible(true)
                                                }
                                            }; logFirebaseEvents("Covered_By_Kudzu", "Get_Start_Covered_By_Kudzu_Clicked", "Get_Start_Covered_By_Kudzu_Clicked","", ""); 
                                        }
                                            , 100)
                                    }
                                >
                                    {t('get_started')}<img
                                        src={appThemeData.arrowWhiteTwofac}
                                        className="md:w-[14px] sm:w-[11px] md:h-[14px] sm:h-[11px] w-[14px] h-[14px] ml-1"
                                        alt="" />
                                </button>
                            </div>
                        </div>}
                />}

                {/* //Covered By Kudzu Discloser agreement */}

                {isCoveredByKudzuDiscloserOpen &&<Modal
                    isOpen={isCoveredByKudzuDiscloserOpen}
                    Fullheight={true}
                    onClose={debounce(closeCustomAlertModal, 100)}
                    isClimbg={true}
                    subtitle={
                        <span className={SubHeadingStyles}>{t("coveredby_kudzu_terms")}</span>
                    }
                    content={<div className="md:pt-5 sm:pt-1 pb-2">
                        {/* <div className="font-hanken-grotesk lg:text-[14px] md:text-[13px] sm:text-[12]
                         text-[13px] font-normal leading-[24px] my-20">
                            <p className="md:pt-5 pt-3">
                                {t('lorem_ipsum_dolor')}</p>
                            <p className="md:pt-5 pt-3">
                                {t('duis_aute_irure_dolor')}
                            </p>
                            <p className="md:pt-5 pt-3 sm:block hidden">
                                {t('lorem_ipsum_dolor_sit_amet')}</p>
                        </div> */}
                        <p className="font-hanken-grotesk lg:text-[16px] md:text-[16px] sm:text-[10] sm:leading-[16px]
                         text-[14px] leading-[20px] font-[500] sm:font-normal md:leading-[24px] mt-8 mb-16 text-[var(--cbk-review-color)]">{t("cbk_please_review")}</p>
                        <div className='flex flex-row gap-2 items-start mt-8'>
                            <label htmlFor="covered-by-kudzu-disclosure-agreement" className="flex items-start gap-2 cursor-pointer">
                                <input
                                    id="covered-by-kudzu-disclosure-agreement"
                                    name="disclosure-agreement"
                                    type="checkbox"
                                    value="accepted"
                                    checked={disclosureAgrmt}
                                    onChange={debounce(() => { setDisclosureAgrmt(!disclosureAgrmt); if (!disclosureAgrmt) { setinfoMessage('') } }, 100)}
                                    className="sr-only"
                                />
                                <span className="flex-shrink-0">
                                    <img 
                                        src={disclosureAgrmt ? RadialFill : appThemeData.radialnull} 
                                        alt="" 
                                        aria-hidden="true"
                                        className='h-[25px] w-[25px] sm:h-[23px] sm:w-[23px] md:h-[25px] md:w-[25px]'
                                    />
                                </span>
                                <span className='sm:w-[25rem] w-full font-hanken-grotesk font-[500] sm:font-[700] text-[14px] 
                                leading-[20px] sm:text-[12px] sm:leading-[20px] md:text-[16px] md:leading-[24px]
                                 text-[var(--i-have-read-color)]'>
                                    {t('i_have_read_and_agree')}
                                    <button type="button" onClick={() => { handleClick('userAgreement') }} className="text-[var(--conditions-clr)] font-hanken-grotesk cursor-pointer"> {t('coveredby_kudzu_terms')}</button>
                                </span>
                            </label>
                        </div>
                        {infoMessage &&
                            <div className='mb-2 w-4/5 self-center justify-center'>
                                {displayErrorMessage(infoMessage)}
                            </div>
                        }
                        <div className="flex justify-center text-center w-full items-center lg:mt-14 mt-12">
                            <button
                                type="button"
                                className="w-full font-hanken-grotesk sm:font-bold font-[600] 
                                lg:text-[18px] md:text-[17px] sm:text-[13px] text-[16px] text-white
                                 bg-[#2965FB] cursor-pointer flex justify-center items-center p-4 focus:outline-none  "
                                 onClick={debounce(() => {if (disclosureAgrmt) {setinfoMessage('');coveredByKudzuOptIn();} else {setinfoMessage(t('please_accept_coveredbykudzu_terms'));}logFirebaseEvents("Covered_By_Kudzu", "Activated_Covered_By_Kudzu_Clicked", "Activated_Covered_By_Kudzu_Clicked","", ""); }, 100)}
                                // onClick={() => { if (disclosureAgrmt) { setinfoMessage(''); debounce(coveredByKudzuOptIn, 100) } else { setinfoMessage(t('please_accept_coveredbykudzu_terms')) } }}
                                autoFocus
                            >
                                {'Activate Covered by Kudzu'}
                            </button>
                        </div>
                    </div>}
                />}

                {/* //Covered By Kudzu opt in success */}

                {isCoveredByKudzuOptInSuccess && <Modal
                    isOpen={isCoveredByKudzuOptInSuccess}
                    onClose={debounce(closeCustomAlertModal, 100)}
                    isClimbg={true}
                    Fullheight={true}
                    subtitle={<div className=" sm:flex sm:flex-col">
                        <span className={SubHeadingStyles2}>{t('congrats')}</span>
                        <span className={SubHeadingStyles}>{'You are now Covered by Kudzu.'}</span>
                        <p className='md:w-auto sm:w-[310px] w-auto font-hanken-grotesk font-[500] md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[27px] lg:leading-[30px] md:leading-[30px] leading-[30px]  text-[var(--matter-content-clr)] pt-5'>{t("covered_by_kudzu_content2")}</p>
                    </div>
                    }
                    content={<div className=" pb-5">
                        <img src={appThemeData.diag} className="block m-auto h-2/5 w-2/5 py-5" alt="" />
                        <div className="flex justify-center text-center w-full items-center">
                            <button
                                type="button"
                                className="focus:outline-none   w-full font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-white bg-[#2965FB] cursor-pointer flex justify-center items-center p-4"
                                onClick={() => { navigate('/Toolkit/ToolkitMenu');logFirebaseEvents("Covered_By_Kudzu", "BackTo_Climb_Covered_By_Kudzu_Clicked", "BackTo_Climb_Covered_By_Kudzu_Clicked","", ""); }}
                                autoFocus
                            >
                                {'Back to Toolkit'}
                            </button>
                        </div>
                    </div>}
                />}

                {/* //Covered By Kudzu ineligible */}

                {isCoveredByKudzuIneligible &&<Modal
                    isOpen={isCoveredByKudzuIneligible}
                    onClose={debounce(closeCustomAlertModal, 100)}
                    isClimbg={true}
                    Fullheight={true}
                    subtitle={<div className="">
                        <span className={SubHeadingStyles4}>{t('sorry')}, </span>
                        <span className={SubHeadingStyles}>{t("it_looks_like_your_not_eligible_right_now")}</span>
                        <p className='mt-4 font-hanken-grotesk font-[500] md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[23px] lg:leading-[30px] md:leading-[30px] leading-[24px] text-[var(--modal-text-heading-clr)]'>
                            {t("you_need_minimum_50")}</p>
                    </div>
                    }
                    content={<div>

                        <img src={appThemeData.coveredByKudzuIneligibleineligibleIcon}
                            className="block m-auto lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-16 md:my-14 sm:my-10 my-10" alt="" />

                        <div className="flex flex-col justify-center items-center gap-8 w-full">
                            <button
                                type="button"
                                className="focus:outline-none   w-full font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-white bg-[#2965FB] cursor-pointer flex justify-center items-center p-4"
                                onClick={() => { navigate('/AccountServices/Spending/TransferMoney') }}
                                autoFocus
                            >
                                {'Add Money to Savings'}
                            </button>
                            <button
                                type="button"
                                className="w-full font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-[var(--can-clr)] cursor-pointer flex justify-center items-center border-[3px] border-[#2965FB] sm:border-0 p-4"
                                onClick={debounce(() => {setIsCoveredByKudzuIneligible(false);navigate('/Toolkit/ToolkitMenu');}, 100)}>
                                {/* {'Maybe later'} */}
                                {t('maybe_later')}
                            </button>
                        </div>
                    </div>}
                />}
                {isCoveredByKudzuIneligibleSetupSavings &&<Modal
                    isOpen={isCoveredByKudzuIneligibleSetupSavings}
                    onClose={debounce(closeCustomAlertModal, 100)}
                    isClimbg={true}
                    Fullheight={true}
                    subtitle={<div className="">
                        <span className={SubHeadingStyles2}>{t('sorry')}, </span>
                        <span className={SubHeadingStyles}>{t("it_looks_like_your_not_eligible_right_now")}</span>
                        <p className='mt-4 font-hanken-grotesk font-[500] md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[23px] lg:leading-[30px] md:leading-[30px] leading-[24px] text-[var(--modal-text-heading-clr)]'>
                            {LineBreaks(t("you_need_savings_account_updated"))}</p>
                    </div>
                    }
                    content={<div>

                        <img src={appThemeData.coveredByKudzuIneligibleineligibleIcon}
                            className="block m-auto lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-16 md:my-14 sm:my-10 my-10" alt="" />

                        <div className="flex flex-col justify-center items-center gap-8 w-full">
                            <button
                                type="button"
                                className=" w-full font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-white bg-[#2965FB] cursor-pointer flex justify-center items-center p-4"
                                onClick={debounce(() => {
                                     setIsCoveredByKudzuIneligibleSetupSavings(false);
                                     setShowPlusModal(false)
                                     if (kudzuPlusTrue) {
                                        showAlertModalPlus(true, "", <p className='mb-6'><span className='text-[var(--modal-text-highlight)]'>{t('Let’s_get_started_climb')}</span>{" "}{t('with_creating_a_Kudzu+_savings_account')}</p>,
                                          t("set_aside_money_for_things_that_matter"),
                                          false, false, t("enroll"), t("may_be_later"), false,
                                          require('../../../../assets/kudzu-plus-images/Benificiary.png'), "", true, "#262B3A",
                                          '', true, '', false, false, false, true, <button type="button"
                                            onClick={() => {
                                                navigate('/SetupSavingsAccount'); dispatch({ type: 'SSN_SCREEN_THROUGH', payload: { ssnScreenThrough: t('climb_savings_enrollment') } }); 
                                            }}
                                            className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[16px] md:text-[16px] sm:text-[14px] text-[16px]
                                  text-white cursor-pointer flex justify-end items-center w-full" >
                                          {t('next')} <img
                                            src={ArrowWhite}
                                            className="md:w-[9px] sm:w-[11px] md:h-[14px] sm:h-[11px] w-[9px] h-[14px] ml-2"
                                            alt="" />
                                        </button>
                                        );
                                      }else{
                                      setIsCoveredByKudzuIneligibleSetupSavingsPostPopup(true);
                                       }
                                     }, 100)}
                                autoFocus
                                onKeyDown={(event) => {
                                    debounce(() => {
                                        if (event.key === "Enter") {
                                            setIsCoveredByKudzuIneligibleSetupSavings(false);
                                            setIsCoveredByKudzuIneligibleSetupSavingsPostPopup(true);
                                            event.stopPropagation();
                                        }
                                    }, 100)(); // Invoke the debounced function immediately
                                }}
                            >
                                {t('enroll_in_savings_account')}
                            </button>
                            <button
                                type="button"
                                className={`w-full font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-[var(--modal-text-highlight)] cursor-pointer flex justify-center items-center p-4 ${isMobile && "sm:border-0 border-[#2965FB] border-[2.5px]"}`}
                                onClick={() => {
                                    setIsCoveredByKudzuIneligibleSetupSavings(false);
                                    navigate('/Toolkit/ToolkitMenu');
                                }}
                                onKeyDown={(event) => {
                                    if (event.key === "Enter") {
                                        setIsCoveredByKudzuIneligibleSetupSavings(false);
                                        navigate('/Toolkit/ToolkitMenu');
                                        event.stopPropagation();
                                    }
                                }}
                            >
                                {t('back_to_climb')}
                            </button>
                        </div>
                    </div>}
                />}
                {isCoveredByKudzuIneligibleSetupSavingsPostPopup &&<Modal
                // bgColor={'bg-[#FEFAEE]'}
                    isOpen={isCoveredByKudzuIneligibleSetupSavingsPostPopup}
                    onClose={debounce(closeCustomAlertModal, 100)}
                    isClimbg={true}
                    Fullheight={true}
                    subtitle={<div className="">
                        <span className={SubHeadingStyles2}>{t('lets_get_started').replace('!', '')} </span>
                        <span className={SubHeadingStyles}>{t("with_creating_a_new_account")}</span>
                        <p className='mt-4 font-hanken-grotesk font-[500] md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[23px] lg:leading-[30px] md:leading-[30px] leading-[24px] text-[var(--modal-text-heading-clr)]'>
                            {t("set_aside_money_for_things_that_matter")}</p>
                    </div>
                    }
                    content={<div>

                        <img src={require('../../../../assets/images/kudzu_piggy_bank.png')}
                            className="block m-auto lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-16 md:my-14 sm:my-10 my-10" alt="" />

                        <div className="flex flex-col justify-center items-center gap-8 w-full">
                            <button
                                type="button"
                                className={`w-full font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-white bg-[#2965FB] cursor-pointer flex justify-center items-center p-4`}
                                onClick={() => { navigate('/SetupSavingsAccount'); dispatch({ type: 'SSN_SCREEN_THROUGH', payload: { ssnScreenThrough: t('climb_savings_enrollment') } }); }}
                                autoFocus
                                onKeyDown={(event) => {
                                    if (event.key === "Enter") {
                                        navigate('/SetupSavingsAccount');
                                        dispatch({ type: 'SSN_SCREEN_THROUGH', payload: { ssnScreenThrough: t('climb_savings_enrollment') } });
                                        event.stopPropagation();
                                    }
                                }}
                            >
                                {t('continue')}
                            </button>
                        </div>
                    </div>}
                />}

                {showAgreementsModel &&<Modal isIframe={true}
                    isOpen={showAgreementsModel}
                    onClose={() => setShowAgreementsModel(false)}
                    title={false}
                    content={<div className="h-[800px] w-full pt-16">
                        {(renderModel == "Link") && <iframe src={policyURL}
                            title="Embedded Website" className="w-full h-[800px] rounded-br-[4rem]"
                        />}
                        {
                            (renderModel == "HTML") && <div>{policyURL}</div>
                        }
                    </div>
                    }
                />}
            </>
            <CustomAlertModel
                isOpen={showModel}
                onClose={debounce(closeCustomAlertModal, 100)}
                image={modelImage}
                highlightMsg={<p className={HighlightMsgStyles}>{highlightMsg}</p>}
                HeaderMsg={<p className={HeaderMsgStyles}>{headerMsg}</p>}
                subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
                btn1Exists={btn1Exists}
                btn2Exists={btn2Exists}
                btn1Text={btn1Text} btn2Text={btn2Text}
                btn1TypeAcpt={btn1TypeAcpt}
                verificationFailure={() => { }}
                footerMsg={<p className={SubHeaderMsgStyles}>{footerMsg}</p>}
                onAcptBtnClick={debounce(onAcptBtnClick, 100)}
                onCancelBtnClick={debounce(onCancelBtnClick, 100)}
                showErrorImg={showErrorImg}
                isBorderNone={isBorderNone}
            />
            <CustomModalPlus isOpen={showPlusModal} onClose={closeModelPlus}
                image={modelImage}
                carousel={carousel}
                comparisonScreen={comparisonScreen}
                summaryParagraph={summaryParagraph ? <p className={summaryParagraphStyles}>{summaryParagraph}</p> : ""}
                isBorderNone={isBorderNone}
                highlightMsg={<p className={HeaderMsgStylesForPlus}> {headerMsg}</p>}
                subHeaderMsg={subHeaderMsg ? <p className={SubHeaderMsgStylesPlus}>{subHeaderMsg}</p> : ""}
                btn1Exists={btn1Exists}
                btn2Exists={btn2Exists}
                btn1Text={btn1Text}
                btn1BgColor={btn1BgColor}
                btn2Text={btn2Text}
                opacityLow={opacityValueLow}
                defaultCornerRadius={false}
                btn1TypeAcpt={btn1TypeAcpt}
                fullWidth={fullWidth}
                onAcptBtnClick={onAcptBtnClickPlusModal}
                onCancelBtnClick={onCancelBtnClickPlusModal}
                footerButtonEnable={footerButtonEnable}
                skipAndNextButtonsEnable={skipAndNextButtonsEnable}
                gradientButton={gradientButton}
                largeImage={largeImage}
                subFooter={subFooter}
            />
            {isLoading && <Loader />}
        </ >

    )
}

export default withOidcSecure(CoveredByKudzu)